import { getAllChannelsAndVendors, getChannel } from "apis/merchandiseApi";
import { doCall } from "common/genericSaga";
import { isFinished, isNotRequested } from "helpers/requestStateHelper";
import { all, call, put, select, take, takeEvery, takeLatest } from "redux-saga/effects";
import {
  errorChannelDetail,
  MERCHANDISE_CHANNELS_FAILED,
  MERCHANDISE_CHANNELS_RECEIVED,
  MERCHANDISE_CHANNELS_REQUESTED,
  MERCHANDISE_CHANNEL_DETAIL_REQUESTED,
  MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED,
  receiveChannelDetail,
  receiveChannelVendorDetails,
  requestChannelDetail,
  requestChannelVendorDetails
} from "./merchandiseActions";

export function* doRequestChannel(action) {
  //if (!action.vendorId) return;
  //Check if initial state has been loaded
  let channels = yield select(state => state.merchandise);
  //if channels not pre-loaded then pre-load them
  if (isNotRequested(channels)) {
    yield put(requestChannelVendorDetails());
    yield take(MERCHANDISE_CHANNELS_RECEIVED);

    channels = yield select(state => state.merchandise);
    const channel = channels[action.id];
    if (!channel) {
      yield put(errorChannelDetail(action.id));
      return;
    }
    if (isNotRequested(channel)) {
      yield put(requestChannelDetail(action.id));
    }
    return;
  }

  //Lookup the channel we wish to load detail for
  const channel = channels[action.id];
  if (isFinished(channels) && !isFinished(channel)) {
    const response = yield call(getChannel, channel.ID, channel.Vendor && channel.Vendor.Locale);

    if (response.errors) throw new Error(response.errors);
    yield put(receiveChannelDetail(action.id, response.data.Channel));
  }
}

export function* doRequestChannels() {
  const response = yield call(getAllChannelsAndVendors);
  if (response.errors) throw new Error(response.errors);

  yield put(receiveChannelVendorDetails(mapToObject(response.data.Channels)));
}

const mapToObject = channels => {
  const result = {};
  channels.forEach(c => {
    result[c.Vendor.ID] = c;
  });
  return result;
};

export function* watchMerchandise() {
  yield all([
    takeEvery(
      MERCHANDISE_CHANNEL_DETAIL_REQUESTED,
      doCall(doRequestChannel, MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED)
    ),
    takeLatest(MERCHANDISE_CHANNELS_REQUESTED, doCall(doRequestChannels, MERCHANDISE_CHANNELS_FAILED))
  ]);
}
